import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { useModal } from "../context/ModalContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const inputCls =
  "w-full mt-2 bg-transparent border-b border-black/15 py-2 outline-none text-black placeholder:text-black/30 focus:border-[color:var(--primary-accent)] transition-colors";

export const WaitlistDialog = () => {
  const { waitlistOpen, setWaitlistOpen } = useModal();
  const [form, setForm] = useState({ name: "", email: "", wallet_type: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      toast.error("Please enter your name and email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, form);
      setDone(true);
      toast.success("You're on the list. We'll be in touch.");
    } catch (err) {
      const msg =
        err?.response?.status === 409
          ? "This email is already on the waitlist."
          : "Something went wrong. Please try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const close = (v) => {
    setWaitlistOpen(v);
    if (!v) {
      setTimeout(() => {
        setDone(false);
        setForm({ name: "", email: "", wallet_type: "" });
      }, 300);
    }
  };

  return (
    <Dialog open={waitlistOpen} onOpenChange={close}>
      <DialogContent
        data-testid="waitlist-dialog"
        className="bg-white border-black/10 text-black sm:max-w-md rounded-2xl"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-bold tracking-tight text-black">
            {done ? "You're in." : "Join the Waitlist"}
          </DialogTitle>
          <DialogDescription className="text-black/50">
            {done
              ? "Thanks for joining. We'll reach out the moment Straight goes live."
              : "Be first to spend stablecoins like cash."}
          </DialogDescription>
        </DialogHeader>

        {!done && (
          <form onSubmit={submit} className="space-y-5 mt-2">
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-black/40">Name</label>
              <input
                data-testid="waitlist-name-input"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className={inputCls}
                placeholder="Satoshi Nakamoto"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-black/40">Email</label>
              <input
                data-testid="waitlist-email-input"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className={inputCls}
                placeholder="you@wallet.xyz"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-black/40">
                Wallet (optional)
              </label>
              <input
                data-testid="waitlist-wallet-input"
                value={form.wallet_type}
                onChange={(e) => setForm({ ...form, wallet_type: e.target.value })}
                className={inputCls}
                placeholder="MetaMask, Rabby, Coinbase..."
              />
            </div>
            <button
              data-testid="waitlist-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-black text-white font-semibold py-3.5 hover:scale-[1.02] transition-transform duration-300 disabled:opacity-60"
            >
              {loading ? "Joining..." : "Join the Waitlist"}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
